import React from 'react';
import {defaultChatBotSettings} from "../../../../consts/settings";
export function ReplyWaitIndicator({chatBotSetting}) {
    return (
        <div className='w-full px-4'>
            <div className='flex gap-2'>
                <div className='bot-icon w-10 h-10 flex-shrink-0 text-gray-500'>
                    <img
                        className="inline-block h-8 w-8 rounded-full"
                        src={chatBotSetting.logo || defaultChatBotSettings.logo}
                        alt=""
                    />
                </div>
                <div className='message-text'>
                    <div className='text-gray-600'>
                        <div className="flex items-center mt-2">
                            <div className="bg-gray-300 rounded-full h-2 w-2 mr-1 animate-pulse"></div>
                            <div className="bg-gray-300 rounded-full h-2 w-2 mr-1 animate-pulse"></div>
                            <div className="bg-gray-300 rounded-full h-2 w-2 animate-pulse"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
